import React, { useEffect, useState } from "react";
import { HashRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Login from "./cmp/Login.jsx";
import Signup from "./cmp/Signup.jsx";
import Admin from "./cmp/Admin.jsx";
import User from "./cmp/admin/User.jsx";
import DashboardHome from "./cmp/admin/DashboardHome.jsx";
import AddUser from "./cmp/admin/AddUser.jsx";
import Studio from "./cmp/admin/Studio.jsx";
import EditUser from "./cmp/admin/EditUser.jsx";
import Notification from "./cmp/admin/Notification.jsx";
import UploadLicense from "./cmp/License.jsx";
import Settings from "./cmp/admin/Settings.jsx";
import Logs from "./cmp/admin/Logs.jsx";
import MainStudio from "./cmp/admin/MainStudio.jsx";
import NotFound from "./cmp/NotFound.jsx";
import checkLicense from "./util/checkFile.js";
import FrameManagement from "./cmp/admin/FrameManagement.jsx";

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem("relay_server_token") !== null;
  return isAuthenticated ? children : <Navigate to="/" replace />;
};

const App = () => {
  // const [isLicensed, setIsLicensed] = useState(null); // null = still loading

  // useEffect(() => {
  //   const verifyLicense = async () => {
  //     const valid = await checkLicense();
  //     if(valid.status === 400 || valid.status === 500)
  //     {
  //       setIsLicensed(false);
  //     }
  //     else
  //     {
  //       setIsLicensed(true);
  //     }
      
  //   };
  //   verifyLicense();
  // }, []);

  // if (isLicensed === null) {
  //   // Optional loader while checking license
  //   return <div style={{ textAlign: "center", marginTop: "100px" }}>Checking license...</div>;
  // }

  // if (!isLicensed) {
  //   // If license invalid → redirect
  //   return (
  //     <Router>
  //       <Routes>
  //         <Route path="/license" element={<UploadLicense />} />
  //         <Route path="*" element={<Navigate to="/license" replace />} />
  //       </Routes>
  //     </Router>
  //   );
  // }

  // If license valid → show app
  return (
    <Router>
      <Routes>
        <Route path="/not-found" element={<NotFound />} />
        <Route path="/" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="*" element={<Navigate to="/" replace />} />

        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <Admin />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<DashboardHome />} />
          <Route path="users" element={<User />} />
          <Route path="users/add-user" element={<AddUser />} />
          <Route path="users/edit-user/:id" element={<EditUser />} />
          <Route path="studio" element={<Studio />} />
          <Route path="main-studio" element={<MainStudio />} />
          <Route path="frame-management" element={<FrameManagement />} />
          <Route path="notification" element={<Notification />} />
          <Route path="settings" element={<Settings />} />
          <Route path="logs" element={<Logs />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
